import cn from 'classnames';
import type { ComponentProps } from 'react';
import * as st from '@src/modules/Authentication/AuthFrom/styles.module.scss';

export const AuthDiv = (props: ComponentProps<'div'>) => {
  const { className, ...rest } = props;
  return <div className={cn(st.form, className)} {...rest} />;
};
